<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import SignUpTrialForm from "@/components/SignUpTrialForm.vue";
import TrialQuestionnaireForm from "@/components/TrialQuestionnaireForm.vue";
import StandardLeft from "@/components/checkout/standard/StandardLeft.vue";


import { DateTime } from "luxon";

export default {
  title: "Dropsmart Trial Sign Up",
  name: "SignUpTrial",
  props: ['routeName'],
  page: {
    meta: [{ name: "description", content: "Dropsmart Trial Sign Up" }],
  },
  components: {
    Header,
    Footer,
    SignUpTrialForm,
    TrialQuestionnaireForm,
    StandardLeft,
  },
  created() {
    this.$on("AccountCreated", (loginData) => {
      this.userData = loginData;
      this.step = "questionnaire";
    });

    this.$on("TrialAccountCreated", (trial) => {
      this.trial = trial;
      this.step = "thank-you";
    });
  },
  mounted() {
    console.log("Show signup page for trial period of " + this.period);
  },
  computed: {
    listLink: function() {
      var link = "https://list.dropsmarteo.com/trial";
      if (this.period === "14" || this.period === "90") {
        link += "z";
      }
      return link;
    },
    period: function() {
      var q = this.$route.query;
      if (q && "p" in q && ["14", "7"].includes(q["p"])) {
        let period = q["p"];
        q = Object.assign({}, this.$route.query);
        delete q.p;
        this.$router.replace({ q });
        localStorage.setItem("signup-trial-period", period);
        return period;
      } else if (this.routeName == "GiftCard") {
        let period = "90";
        return period;
      } else {
        let period = localStorage.getItem("signup-trial-period");
        return period ? period : "14";
      }
    },
  },
  data() {
    return {
      step: "signup",
      userData: null,
    };
  },
  methods: {
    formatDateTime: function(dt) {
      return DateTime.fromISO(dt).toFormat("DDD");
    },
  },
};
</script>
<template>
  <main>
    <Header :hideMenu="true" v-if="this.routeName != 'GiftCard'"/>
    <div class="signup-trial-container" v-if="step === 'signup'">
      <SignUpTrialForm :routeName="routeName"/>
    </div>
    <div v-if="false">
      <StandardLeft :routeName="routeName" v-if="this.routeName == 'GiftCard'"/>
    </div>
    <div class="trial-questionnaire-form-container" v-if="step === 'questionnaire'">
      <TrialQuestionnaireForm
        :user="userData.user"
        :token="userData.token.token"
        :period="period"
        :routeName="routeName"
      />
    </div>
    <div
      v-if="step === 'thank-you'"
      class="container text-center content-thank"
    >
      <img src="../assets/images/icon-thank-you.png" alt="Thank You!" />
      <div v-if="this.routeName !== 'GiftCard'" style="margin-top: 3em; text-align: center; padding: 0.8em;">
        <h2>
          Congratulations!
          <br />
          <br />
          As of now, you're officially a Dropsmarter! 🙂
          <br />
          <br />
          P.S. if you opted for customized guidance keep an eye on your inbox -
          since we're going to send you TOP TIPS on how to leverage the power of
          Dropsmart!
          <br />
          <br />
          If you didn't do it but wish to receive the instructions -
          <a :href="listLink">SIGN UP NOW</a>!
          <br />
          <br />
          HAPPY EXPLORATION AND SUCCESSFUL BLENDING!
          <br />
          <br />
          Trial ends on
          <strong>{{ this.formatDateTime(trial.trialEnd) }}</strong>
          <br />
          <br />
          Click <a href="https://center.dropsmarteo.com/login">Here</a> And Start
          Using Dropsmart!
        </h2>
      </div>

      <div v-if="this.routeName === 'GiftCard'" style="margin-top: 3em; text-align: center; padding: 0.8em;">
        <h2>
          Congratulations!
          <br />
          <br />
          You're officially a Dropsmarter! 🙂
          <br />
          <br />
          P.S. if you opted for customized guidance, keep an eye on your inbox since we’re going to send you TOP TIPS on how to leverage the power of Dropsmart!
          <br />
          <br />
          HAPPY EXPLORATION AND SUCCESSFUL BLENDING!
          <br />
          <br />
          Your gift ends on
          <strong>{{ this.formatDateTime(trial.trialEnd) }}</strong>.
          <br />
          <br />
          Click <a class="click-here-link" href="https://center.dropsmarteo.com/login">here</a> and start
          using Dropsmart!
        </h2>
      </div>
    </div>

    <Footer v-if="this.routeName != 'GiftCard'"/>
  </main>
</template>
<style lang="scss">
$vs-state-active-bg: #dddbdb;
$vs-state-active-color: #333;
@import "vue-select/src/scss/vue-select.scss";
@font-face {
  font-family: OpenSans;
  src: url(../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

a {
  color: $link-color;
}

.box-login {
  color: $color;
  a {
    color: #509610;
    &:hover {
      color: $color;
    }
  }
}
main {
  overflow-x: hidden;
  height: 100%;
}

.signup-trial-container, .trial-questionnaire-form-container {
  display: flex;
  justify-content: center;
}

.box-sign-up {
  padding: 0 15px;
  max-width: 450px;
}
.login-title {
  color: #000000;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 0;
  padding: 0px 0 15px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}
.checkout-checkbox {
  margin: 15px 0 10px;
}
.textinfo {
  color: #434343;
  font-size: 18px;
  text-align: center;
  max-width: 350px;
  margin: 15px auto;
  span {
    font-weight: 700;
  }
}
.button-login {
  background: #ffffff;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #79b867;
  font-size: 20px;
  font-weight: 400;
  line-height: 53px;
  margin-bottom: 8px;
  padding: 0 15px;
  text-transform: uppercase;
  width: 100%;
  .spinner-border {
    vertical-align: middle;
  }
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}
.btn-more {
  background: #79b867;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #ffffff;
  display: block;
  font-size: 20px;
  font-weight: 700;
  line-height: 53px;
  margin-bottom: 8px;
  padding: 0 15px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  &:hover {
    text-decoration: none;
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
}
.text-privacy {
  font-size: 14px;
  text-align: center;
  max-width: 310px;
  margin: 25px auto;
}
.textGDPR {
  font-size: 16px;
  margin: 0;
  text-align: center;
}
.box-sign-up {
  fieldset {
    margin: 30px 0px 5px;
  }
}
.signup-checkbox {
  .custom-control {
    padding-left: 50px;
  }
  .custom-control-label {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 25px;
    &::after {
      top: 50%;
      margin-top: -11px;
      margin-left: -12px;
      width: 21px;
      height: 21px;
    }
    &::before {
      background-color: #e5e5e5;
      border-color: #e5e5e5 !important;
      top: 50%;
      margin-top: -11px;
      margin-left: -12px;
      border-radius: 0;
      width: 21px;
      height: 21px;
    }
  }
  .custom-control-input:checked ~ .custom-control-label::before,
  .was-validated
    .custom-control-input:valid:checked
    ~ .custom-control-label::before,
  .custom-control-input.is-valid:checked ~ .custom-control-label::before {
    border-color: #68a432 !important;
    background-color: #68a432 !important;
  }
  .was-validated
    .custom-control-input:valid:focus
    ~ .custom-control-label::before,
  .custom-control-input.is-valid:focus ~ .custom-control-label::before {
    box-shadow: none;
  }
  .was-validated .custom-control-input:valid ~ .custom-control-label,
  .custom-control-input.is-valid ~ .custom-control-label {
    color: #000000;
  }
  .was-validated
    .custom-control-input:invalid:focus:not(:checked)
    ~ .custom-control-label::before,
  .custom-control-input.is-invalid:focus:not(:checked)
    ~ .custom-control-label::before {
  }
  .was-validated
    .custom-control-input:valid:checked
    ~ .custom-control-label::before,
  .custom-control-input.is-valid:checked ~ .custom-control-label::before {
    border-color: #e5e5e5;
  }
  .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23000'/%3e%3c/svg%3e");
  }
  .was-validated .custom-control-input:invalid ~ .custom-control-label,
  .custom-control-input.is-invalid ~ .custom-control-label {
  }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none !important;
  }
  .was-validated .custom-control-input:invalid ~ .custom-control-label::before,
  .custom-control-input.is-invalid ~ .custom-control-label::before {
    border-color: #e5e5e5 !important;
    outline: none;
    box-shadow: none !important;
  }

  form {
    max-width: 30em;
    .choice-selector {
      border-radius: 14px;
      width: 100px;
    }
    .choice-selector:focus {
      box-shadow: none;
      border-color: #f0f0f0;
    }
    .combobox {
      height: auto;
      width: 80%;
      margin: auto;
      line-height: $line-height-input;
      border: $border-input;
      border-radius: 6px !important;
    }

    .combobox .vs__dropdown-toggle,
    .combobox .vs__dropdown-menu {
      background: $bg-input;
      border: none;
      color: $color-input;
      li,
      span,
      div {
        &:checked {
          background-color: #fafafa;
          border: 1px solid #dcdcdc;
          color: #444;
        }
      }
    }

    .combobox .vs__clear {
      display: none;
    }
    .combobox .vs__open-indicator {
      fill: #394066;
    }
  }
}

//MODAL
#modalLogin,
#modalRecoverPassword {
  .modal-dialog {
    max-width: 575px;
    .modal-content {
      border: 0;
      border-radius: 0;
      h2 {
        color: #000000;
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 35px;
        padding-top: 60px;
        text-align: center;
        text-transform: uppercase;
        width: 100%;
      }
      p {
        color: #000000;
        max-width: 360px;
        margin: 0 auto 25px;
        text-align: center;
        font-size: 18px;
      }
      .modal-header {
        border: 0;
        padding-top: 15px;
        flex-direction: column;
        p {
          color: #000000;
          font-size: 18px;
          margin: 0 auto;
          max-width: 360px;
          padding-top: 15px;
          text-align: center;
        }
      }
      .modal-footer {
        border: 0;
        padding-top: 0;
        padding-bottom: 65px;
        text-align: center;
      }
      .button-login {
        background: #79b867;
        border: 1px solid #79b867;
        border-radius: 50px;
        color: #ffffff;
        font-size: 20px;
        font-weight: 700;
        line-height: 53px;
        margin-top: 35px;
        padding: 0 15px;
        text-transform: uppercase;
        width: 100%;
        .spinner-border {
          vertical-align: middle;
        }
        &:hover {
          background: #000000;
          border-color: #000000;
          color: #ffffff;
        }
        &:focus {
          outline: none;
        }
      }
      .forgot-password {
        color: #666666;
        font-size: 13px;
        width: 100%;
      }
      .support {
        font-size: 14px;
        text-align: center;
        display: block;
        margin: 35px 0 30px;
        &:hover {
          color: #79b867;
          text-decoration: none;
        }
      }
    }
  }
}

#modalRecoverPassword {
  .modal-dialog {
    .modal-content {
      h2 {
        margin-bottom: 15px;
      }
      .button-login {
        margin-top: 25px;
      }
      .support {
        margin-bottom: 50px;
      }
    }
  }
}

.click-here-link:hover {
  color: black;
}

@media screen and (max-width: 639px) {
  #modalLogin,
  #modalRecoverPassword {
    .modal-header {
      padding-top: 55px !important;
      h2 {
        font-size: 18px;
      }
    }
    .modal-footer {
      padding-top: 25px !important;
    }
    .button-login {
      font-size: 18px !important;
    }
  }
}
.thank-you {
  background-image: url("../assets/images/img-vectors-thankyou.png");
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  .logo img {
    max-width: 236px;
    width: 100%;
  }
}
.container {
  .row {
    min-height: 175px;
  }
  h1 {
    font-size: 36px;
    color: #000000;
    font-weight: 700;
    margin-top: 20px;
    text-transform: uppercase;
  }
  h2 {
    color: #000000;
    font-size: 22px;
    line-height: 34px;
    margin-top: 30px;
    span {
      color: #499f30;
      text-transform: capitalize;
    }
  }
}
.content-thank {
  padding: 2% 0;
}
</style>
